import script from "./Error404.vue?vue&type=script&lang=ts&setup=true"
export * from "./Error404.vue?vue&type=script&lang=ts&setup=true"

import "./Error404.vue?vue&type=style&index=0&id=7244fead&lang=less"

const __exports__ = script;

export default __exports__